import { render, staticRenderFns } from "./TwSelect.vue?vue&type=template&id=c032538c&"
import script from "./TwSelect.vue?vue&type=script&lang=js&"
export * from "./TwSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports